import axios from "axios";
import { getBaseUrlOldForEnviornment } from "utils/constants";
export async function APIHandlerOldDashboard({ method, url, data }) {
  const baseUrl = getBaseUrlOldForEnviornment();

  const headers = {
    "Content-Type": "application/json",
  };

  const request = {
    url: `${baseUrl}/${url}`,
    method,
    headers,
    data: JSON.stringify(data),
    timeout: 100000,
  };

  try {
    return await axios.request(request);
  } catch (error) {
    console.error({ error });
    return Promise.reject(error);
  }
}
